import { Component, OnInit } from '@angular/core';
import{CommonService} from '../../services/common.service';
import { organizationDTO } from 'src/app/models/providersDTO';
@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.css']
})
export class AdminHeaderComponent implements OnInit {

  public headerDetails: organizationDTO = new organizationDTO();
  contentPath:string;
  constructor(private commonService:CommonService) { }

  ngOnInit() {
    
this.commonService.getOrganizationDetails().then((formdata: organizationDTO) => {
  this.headerDetails= formdata[0];
});
this.contentPath=localStorage.getItem('ContentPath');
  }

}
